<template>
  <div>
    <CustomTable
      :data="newTableData"
      :header="tableHeader"
      @pageSizeChange="handleSizeChange"
      @currentPageChange="handleCurrentChange"
      :settings="{
        isLoading: loading,
        currentPage: pageNum,
        pageSize: pageSize,
        total: total
      }"
      >
      <template slot="fujian" slot-scope="data">
        <el-button @click="openAnnTemList(data.scope.row.templateId)" size="small">查看附件模板</el-button>
      </template>
      <template slot="doc" slot-scope="data">
        <el-button @click="openDocList(data.scope.row.templateId, data.scope.row.notaryStatus)" size="small">查看公证文书模板</el-button>
      </template>
      <template slot="action" slot-scope="data">
        <el-button @click="openDetails(data.scope.row.templateId, data.scope.row.notaryStatus)" size="small">查看模板</el-button>
        <el-button type="primary" @click="onPass(data.scope.row.templateId)" size="small" :disabled="data.scope.row.notaryStatus==3">{{data.scope.row.notaryStatus==3?'已审核':'审核通过'}}</el-button>
        <el-button type="danger" @click="onReject(data.scope.row.templateId)" size="small" :disabled="data.scope.row.notaryStatus==3">驳回</el-button>
      </template>
    </CustomTable>

    <TemDetails ref="temDetails" @updateList="getList"/>
    <PassDialog ref="passDialog" :templateId="templateId" @passSuccess="getList"/>
    <RejectDialog ref="rejectDialog" :templateId="templateId" @submited="getList"/>
  </div>
</template>

<script>
import { conVertDate } from "@/utils/tools";
import TemDetails from './details';
import PassDialog from './passDialog';
import RejectDialog from './rejectDialog';
import CustomTable from '@/components/custom-table.vue';
export default {
  components: {
    TemDetails,
    PassDialog,
    RejectDialog,
    CustomTable
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      loading: false,
      templateId: 0,
      tableHeader: [
        {
          prop: 'templateName',
          label: '模版名称'
        },
        {
          prop: 'templateStatus_name',
          label: '模版状态'
        },
        {
          prop: 'notaryStatus_name',
          label: '公证开通状态'
        },
        {
          prop: 'createTime',
          label: '创建时间'
        },
        {
          prop: 'updateTime',
          label: '更新时间'
        },
        {
          label: '附件模板',
          width: '150',
          slotName: 'fujian',
        },
        {
          label: '下属公证文书模板',
          width: '150',
          slotName: 'doc'
        },
        {
          label: '操作',
          width: '280',
          slotName: 'action'
        }
      ]
    }
  },
  mounted() {
    this.getList()
    // this.$api.getToken().then(res => {
    //   if (res.data.code === 200) {
    //     localStorage.setItem('token_yu', res.data.data);
    //     this.getList();
    //   }
    // })
  },
  computed: {
    newTableData() {
      let temData = this.tableData;
      
      temData.map((item, index) => {
        item.i = index + 1 + ((this.pageNum-1)*this.pageSize);
        item.templateStatus_name = item.templateStatus == 1? '有效' : '无效';
        item.createTime = conVertDate(item.createTime, false);
        item.updateTime = conVertDate(item.updateTime, false);
        switch (item.notaryStatus) {
          case 0:
            item.notaryStatus_name = '未开通';
            break;
          case 1:
            item.notaryStatus_name = '电子签审核中';
            break;
          case 2:
            item.notaryStatus_name = '公证处审核中';
            break;
          case 3:
            item.notaryStatus_name = '审核通过';
            break;
        
          default:
            break;
        }
      });
      return temData;
    }
  },
  methods: {
    test(scope) {
      console.log(scope)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$api.templateList({
        "currentPage": this.pageNum,
        "pageSize": this.pageSize,
        "notaryNo": this.$store.state.login.userInfo.officeCode
      }).then(res => {
        console.log(res);
        if (res.data.code === 200) {
          this.tableData = res.data.data;
          this.total = parseInt(res.data.total);
        } else {
          // 统一错误处理
          this.$message.error(res.data.msg || "获取模板列表失败");
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    // 打开模版详情
    openDetails(templateId, notaryStatus) {
      console.log()
      this.$refs.temDetails.open(templateId, 'tem', notaryStatus)
    },
    // 打开下属的公证文书模版
    openDocList(templateId, notaryStatus) {
      this.$router.push({
        path: '/templateExamine/docList',
        query: {
          busiTemplateId: templateId,
          notaryStatus: notaryStatus
        }
      })
    },
    // 打开附件模板
    openAnnTemList(templateId) {
       this.$router.push({
        path: '/templateExamine/annexTemplateList',
        query: {
          busiTemplateId: templateId
        }
      })
    },
    // 点击审核通过
    onPass(templateId) {
      this.templateId = templateId;
      this.$refs.passDialog.open();
    },
    // 点击驳回
    onReject(templateId) {
      this.templateId = templateId;
      this.$refs.rejectDialog.open();
    }
  }
}
</script>
<style scoped>

</style>